import React from 'react';
import queryString from 'qs';
import Banner from 'app/components/Banner';
import FooterLinks from 'app/components/FooterLinks';
import StyledLogin from './styled';
import LoginForm from './LoginForm';
import SideBar from '../SideBar';
import Spinner from '../Spinner';

class Login extends React.Component {
    componentDidMount() {
        const { isLoggedIn, handleAuth, push, location } = this.props;
        const qs = location && location.search && queryString.parse(location.search, { ignoreQueryPrefix: true });
        const { nexturl } = qs || {};
        const { from } = location.state || { from: { pathname: nexturl || '/' } };

        if (isLoggedIn && !nexturl) {
            push(from);
        }
        if (location && location.hash) {
            handleAuth(location.hash);
        }
    }

    render() {
        const { errorMsg } = this.props;
        const { hash } = this.props.location;

        if (hash && !errorMsg) {
            return <Spinner />;
        }

        return (
            <>
                <StyledLogin>
                    <div className="container">
                        <div className="row">
                            <div className="span6">
                                <SideBar />
                            </div>
                            <div className="span6">
                                <LoginForm {...this.props} />
                            </div>
                        </div>
                        <div className="white-bg" />
                        <Banner />
                    </div>
                </StyledLogin>
                <FooterLinks />
            </>
        );
    }
}

export default Login;
